<template>
  <div class="navbar_wrap hidden-xs-only">
    <div class="navbar_container">
      <div class="navbar_left">
        <img src="@/assets/img/home/yw_logo.png" alt="亿微电子..." />
		<p>亿微电子</p>
      </div>
      <div class="navbar_right">
        <el-menu
          :default-active="activeIndex"
          class="el_menu_demo"
          mode="horizontal"
          background-color="rgba(0,0,0,0)"
          :text-color="navBackground"
          :active-text-color="navBackground"
          @select="changeCurrentPage"
        >
          <el-menu-item index="1" class="menu_item">首页</el-menu-item>
          <el-menu-item index="2" class="menu_item">公司简介</el-menu-item>
          <el-submenu index="3" class="custom-submenu">
            <template slot="title">产品中心</template>
            <el-menu-item index="3-1" class="menu_item">产品类型</el-menu-item>
            <el-menu-item index="3-2" class="menu_item">产品应用</el-menu-item>
          </el-submenu>
<!--          <el-menu-item index="4" class="menu_item">解决方案</el-menu-item>
          <el-menu-item index="5" class="menu_item">文档中心</el-menu-item>
		  <el-menu-item index="6" class="menu_item">新闻动态</el-menu-item> -->
		  <el-menu-item index="7" class="menu_item">联系我们</el-menu-item>
		  <el-menu-item index="8" class="menu_item">用户登录</el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
      navBackground:'#fff'
    }
  },
  props: {
    selectIndex: {
      type: String,
      default: '0',
    },
  },
  mounted() {
    this.activeIndex = this.selectIndex
    window.onscroll = () => {
      if(document.documentElement.scrollTop > 390){
        this.navBackground = '#000'
      }else{
        this.navBackground = '#fff'
      }
    }
  },
  methods: {
    changeCurrentPage(index) {
      this.activeIndex = index
      switch (this.activeIndex) {
        case '1':
          this.$router.push('/home').catch((v) => {})
          break
        case '2':
          this.$router.push('/profiles').catch((v) => {})
          break
        case '3-1':
          this.$router.push('/product/1').catch((v) => {})
          break
        case '3-2':
          this.$router.push('/product/2').catch((v) => {})
          break
        case '4':
          this.$router.push('/solution').catch((v) => {})
          break
        case '5':
          this.$router.push('/document').catch((v) => {})
          break
        case '6':
          this.$router.push('/news').catch((v) => {})
          break
        case '7':
          this.$router.push('/contact').catch((v) => {})
          break
        case '8':
		  window.location.href = 'https://user.faywdz.com/';
          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="scss">
.navbar_wrap {
  width: 100%;
  height: 70px;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: saturate(180%) blur(0.5rem);
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  .navbar_container {
    width: 70%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .navbar_left {
      display: flex;
      align-items: center;
      height: 100%;
      img {
        width: 42px;
        cursor: pointer;
      }
      p {
        width: 100px;
        font-size: 24px;
        margin-left: 10px;
        // color: white;
		color: #1e91ca;
	  }
    }
    .navbar_right {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 20px;
      a {
        text-decoration: none;
        color: #0038a4;
        display: inline-block;
        width: 100px;
        background: #ffa400;
        line-height: 27px;
        text-align: center;
        border-radius: 20px;
        padding: 5px;
      }
      .el_menu_demo {
        border: none;
      }
      .el-submenu__title {
        font-size: 18px;
      }
      .menu_item {
        font-size: 18px;
        &:hover {
          font-weight: 600;
          background: transparent !important;
        }
      }
    }
  }
}
// 修改二级菜单项中的字体大小
.el-menu--dropdown .el-menu-item,
.el-menu--popup .el-menu-item {
  font-size: 18px !important;
}
</style>